import React, { useCallback, useEffect, useState } from "react";
import { useTabs } from "../../hooks/lib/useTabs";
// import { useHashScroll } from "../../hooks/custom/useHashScroll";
import {
  ICoreValuesPointsData,
  ICoreValuesStatementData,
  IMissionVisionData,
} from "../../exports/interfaces";
import { getVisibleTabs, truncateText } from "../../exports/functions";
import { useMobile } from "../../hooks/custom/useMobile";
import TabSidebar from "../TabSidebar";
import { useHashScroll } from "../../hooks/custom/useHashScroll";

const goal = [
  {
    description: `<ul>
      <li>
        Deliver World-Class Education: Establish academic programs
        that meet global standards while being relevant to Nepal’s context.
      </li>
      <li>
        Promote Research and Innovation: Encourage faculty and students
        to lead research that addresses pressing social, economic, and environmental issues.
      </li>
      <li>
        Foster Inclusive Access: Provide pathways and scholarships
        for students from marginalized and disadvantaged backgrounds.
      </li>
      <li>
        Engage with Communities: Connect learning to real-world challenges
        through partnerships with local industries, communities, and government.
      </li>
      <li>
        Develop Global Partnerships: Collaborate with international institutions
        to enrich learning, research, and cultural exchange.
      </li>
      <li>
        Shape Responsible Leadership: Prepare graduates who combine knowledge
        with civic responsibility, compassion, and vision.
      </li>
    </ul>`,
  },
];

export const MissionVision = (props: {
  visionStatement: IMissionVisionData[];
  missionStatement: IMissionVisionData[];
  coreValuesStatement: ICoreValuesStatementData[];
  coreValuesPoints: ICoreValuesPointsData[];
}) => {
  useTabs();
  const isMobile = useMobile();
  const [openSidebar, setOpenSidebar] = useState(false);
  const handleTabHash = (hash: string) => {
    const tabLink = document.querySelector(
      `.td_tab_links a[href="${hash}"]`,
    ) as HTMLAnchorElement | null;
    tabLink?.click();
  };

  useHashScroll(120, handleTabHash);
  const [activeTab, setActiveTab] = useState<string>("#td_tab_1");

  const handleTabClick = (hash: string) => {
    setActiveTab(hash);
  };

  const [allTabData, setAllTabData] = useState<{
    [key: string]: any[];
  }>({});

  const fetchAllTabData = useCallback(async () => {
    setAllTabData({
      "#td_tab_1": props?.visionStatement,
      "#td_tab_2": props?.missionStatement,
      "#td_tab_3": props?.coreValuesStatement,
      "#td_tab_4": goal,
    });
  }, [
    props?.coreValuesStatement,
    props?.missionStatement,
    props?.visionStatement,
  ]);

  useEffect(() => {
    fetchAllTabData();
  }, [fetchAllTabData]);

  const allTabs = React.useMemo(
    () => [
      { id: "#td_tab_1", label: "Vision" },
      { id: "#td_tab_2", label: "Mission" },
      { id: "#td_tab_3", label: "Core Values" },
      { id: "#td_tab_4", label: "Goals" },
    ],
    [],
  );

  const visibleTabs = React.useMemo(() => {
    return getVisibleTabs(allTabs, activeTab, isMobile ? 2 : 4);
  }, [allTabs, activeTab, isMobile]);

  const tabData = allTabData[activeTab] || [];

  return (
    <>
      <section id="vision-mission">
        <div className="td_height_120 td_height_lg_40" />
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <h2 className="td_section_title td_fs_48 mb-0">
              Vision, Mission & Core Values
            </h2>
            <div className="td_height_30 td_height_lg_30" />
          </div>

          <div className="td_course_details">
            <div className="td_tabs td_style_1">
              <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_16 td_heading_color align-items-center justify-content-between">
                <div className="td_tab_links td_style_2">
                  {visibleTabs.map((tab) => (
                    <li
                      key={tab.id}
                      className={activeTab === tab.id ? "active" : ""}
                    >
                      <a
                        href={tab.id}
                        onClick={() => handleTabClick(tab.id)}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={tab.label}
                      >
                        {truncateText(tab.label, isMobile ? 10 : 30)}
                      </a>
                    </li>
                  ))}
                </div>
                {isMobile && (
                  <li>
                    <div className="course_sidebar_toggle_wrapper">
                      <button
                        className="course_sidebar_toggle mt-1"
                        onClick={() => setOpenSidebar(true)}
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                        {/* <span></span>
                  <span></span>
                  <span></span> */}
                      </button>
                    </div>
                  </li>
                )}
              </ul>

              <div className="td_tab_body td_fs_18">
                {/* Vision */}
                <div className="td_tab active" id="td_tab_1">
                  <p
                    className="custom-text-p"
                    dangerouslySetInnerHTML={{
                      __html: tabData[0]?.description,
                    }}
                  />
                </div>

                {/* Mission */}
                <div className="td_tab" id="td_tab_2">
                  <p className="custom-text-p">{tabData[0]?.description}</p>
                </div>

                {/* Core Values */}
                <div className="td_tab" id="td_tab_3">
                  <p
                    className="custom-text-p"
                    dangerouslySetInnerHTML={{
                      __html: tabData[0]?.description,
                    }}
                  />
                  {/* <ul>
                    {props?.coreValuesPoints?.map((item) => {
                      return <li>{item?.description}</li>;
                    })}
                  </ul> */}
                </div>

                {/* Goals */}
                <div className="td_tab" id="td_tab_4">
                  <p
                    className="custom-text-p"
                    dangerouslySetInnerHTML={{
                      __html: tabData[0]?.description,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TabSidebar
        title="About"
        tabs={allTabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      />
    </>
  );
};
